<script setup lang="ts">
import { computed } from 'vue'

interface BreadcrumbItem {
	text: string
	link?: string
}
const { items } = defineProps({
	items: {
		type: Array as () => BreadcrumbItem[],
		default: () => [],
	},
})
const linkClass = computed(() =>
	items.map((_, index) =>
		index < items.length - 1
			? 'text-black hover:text-indigo-800'
			: 'text-n-500 hover:text-indigo-800',
	),
)
const textClass = computed(() =>
	items.map((_, index) =>
		index < items.length - 1 ? 'text-black' : 'text-n-500',
	),
)
</script>
<template>
	<nav aria-label="Breadcrumb" class="text-indigo-600">
		<ol class="flex gap-4px pl-0 leading-none">
			<li
				v-for="(item, index) in items"
				:key="index"
				class="typography-s1-reg flex items-center gap-4px"
			>
				<a v-if="item.link" :href="item.link" :class="linkClass[index]">
					{{ item.text }}
				</a>
				<span v-else :class="textClass[index]">{{ item.text }}</span>
				<span v-if="index < items.length - 1" class="mx-8px text-n-300">/</span>
			</li>
		</ol>
	</nav>
</template>
